import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ContatoStatus } from '../models/contato-status';
import { globals } from '../globals';

@Injectable({
  providedIn: 'root'
})
export class ContatoStatusService {

  constructor(private http: HttpClient) { }

  consultar() {
    return this.http.get<ContatoStatus[]>(globals.apiUrl + '/api/ContatoStatus/Lista');
  }

  consultarPorId(id) {
    return this.http.get<any>(globals.apiUrl + '/api/ContatoStatus/Buscar',
      { params: new HttpParams().set('id', id) });
  }

  salvar(contatoStatus: ContatoStatus) {
    return this.http.post(globals.apiUrl + '/api/ContatoStatus/Salvar', contatoStatus,
      { responseType: 'text' });
  }

  excluir(id) {
    return this.http.delete(globals.apiUrl + '/api/ContatoStatus/Excluir',
      { params: new HttpParams().set('id', id) });
  }
}
